import { captureException, captureMessage } from '@sentry/node';

import { wave } from './config';

const GET_OFFERS_ENDPOINT = '/v2/offers/eligible';

export async function getOffers() {
  try {
    const response = await wave.get(GET_OFFERS_ENDPOINT);
    const offers = response.data?.payload?.offers;
    if (!offers) {
      captureMessage(`Fetched Unproccessable entity from ${GET_OFFERS_ENDPOINT}`);
      return [];
    }

    if (!offers.length) captureMessage(`Fetched empty array from ${GET_OFFERS_ENDPOINT}`);

    return offers;
  } catch (error) {
    captureException(error);
    console.error(error);
    return [];
  }
}
